import React, { useRef } from "react"
import {
  Box,
  Container,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material"
import Vanta from "../../../vanta"

// Icons
import Shop from "public/images/icons/shopping-bag.png"
import User from "public/images/icons/user.png"
import Wifi from "public/images/icons/wifi.png"

import Image from "next/image"

import { ParallaxProvider } from "react-scroll-parallax"
import MainCard from "../../../../common/main-card"
import LandingAppBar from "../app-bar"
import MainSlider from "./components/MainSlider"

const LandingHeader = () => {
  const vantaRef = useRef(null)
  return (
    <ParallaxProvider>
      <Vanta childrenRef={vantaRef}>
        <Box ref={vantaRef} >
          <Container
            sx={{
              alignItems: "center",
              mb: 5,
              minHeight: "100vh"
            }}
          >
            <LandingAppBar />
            <Box
              sx={{
                minHeight: "calc(100vh - 220px)",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                padding: 1,
              }}
            >
              <MainSlider />
            </Box>

            <Grid container spacing={1.5} sx={{ pb: 1, mt: 4 }}>
              <Grid item xs={12} md={4}>
                <MainCard
                  shadow={3}
                  sx={{
                    borderRadius: "25px",
                    background: "rgba(6, 5, 19, 0.4)",
                    backdropFilter: "blur(5px)",
                    color: "#fff"
                  }}
                >
                  <ListItem>
                    <ListItemIcon>
                      <Image src={User} alt='user' width={35} />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Typography variant='h5'>با ارائه ضامن</Typography>}
                      secondary={<Typography variant='caption'>به همراه یک برگ چک صیادی</Typography>}
                    />
                  </ListItem>
                </MainCard>
              </Grid>
              <Grid item xs={12} md={4}>
                <MainCard
                  shadow={0}
                  sx={{
                    width: "100%",
                    borderRadius: "25px",
                    background: "rgba(6, 5, 19, 0.4)",
                    backdropFilter: "blur(5px)",
                    color: "#fff"
                  }}
                >
                  <ListItem>
                    <ListItemIcon>
                      <Image src={Shop} alt='user' width={45} />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Typography variant='h5'>خرید از شبکه پذیرندگان منتخب</Typography>}
                      secondary={<Typography variant='caption'>از فروشگاه های معتبر و متنوع خرید کن</Typography>}
                    />
                  </ListItem>
                </MainCard>
              </Grid>
              <Grid item xs={12} md={4}>
                <MainCard
                  shadow={0}
                  sx={{
                    width: "100%",
                    borderRadius: "25px",
                    background: "rgba(6, 5, 19, 0.4)",
                    backdropFilter: "blur(5px)",
                    color: "#fff"
                  }}
                >
                  <ListItem>
                    <ListItemIcon>
                      <Image src={Wifi} alt='user' width={35} />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Typography variant='h5'>فرایند تماماً آنلاین</Typography>}
                      secondary={<Typography variant='caption'>از خونه درخواست وام بده</Typography>}
                    />
                  </ListItem>
                </MainCard>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Vanta>
    </ParallaxProvider>
  )
}

export default LandingHeader
